export const AuthJWT: {
  token: string | null;
} = { token: null };
